function headerMain() {
  $('.js-header').css('background-image', 'url('+$('.slick-active').data('href')+')');
  $('.js-header').css('background-color', 'rgba(0, 0, 0, '+$('.slick-active').data('blackout')+')');
  // Событие нажатия на стрелку слайдера вперед
  $('.js-header .header-slider-arrow--right').click(function() {
    $('.js-header').addClass('anim-right');
    setTimeout(function() {
      $('.js-header').css('background-image', 'url('+$('.slick-active').data('href')+')');
      $('.js-header').css('background-color',' rgba(0, 0, 0, '+$('.slick-active').data('blackout')+')');
    }, 750);
    setTimeout(function() {
      // удаление класса спустя время самой анимации
      $('.js-header').removeClass('anim-right');
  }, 1500);
  });
  // Событие нажатия на стрелку слайдера назад
  $('.js-header .header-slider-arrow--left').click(function() {
    $('.js-header').addClass('anim-right');
    setTimeout(function() {
      $('.js-header').css('background-image', 'url('+$('.slick-active').data('href')+')');
      $('.js-header').css('background-color',' rgba(0, 0, 0, '+$('.slick-active').data('blackout')+')');
    }, 750);
    setTimeout(function() {
      // удаление класса спустя время самой анимации
      $('.js-header').removeClass('anim-right');
  }, 1500);
  });

  // Событие нажатия на дотсы
  $('.js-header .slick-dots li').click(function() {
    $('.js-header').addClass('anim-right');
    setTimeout(function() {
      $('.js-header').css('background-image', 'url('+$('.slick-active').data('href')+')');
      $('.js-header').css('background-color', 'rgba(0, 0, 0, '+$('.slick-active').data('blackout')+')');
    }, 750);
    setTimeout(function() {
      // удаление класса спустя время самой анимации
      $('.js-header').removeClass('anim-right');
  }, 1500);
  });


  // Обработка модального окна с кнопками навигации (появление и закрытие)
  $(".js-burger").click(function() {
    $(".js-overlay").show();
    $(".js-modal").show();
  });
  $(".js-btn-close").click(function() {
    $(".js-overlay").hide();
    $(".js-modal").hide();
  });
  // Обработка модального окна с поиском (появление и закрытие)
  $(".js-burger-search").click(function() {
    $(".js-overlay-search").show();
    $(".js-modal-search").show();
  });
  $(".js-btn-close-search").click(function() {
    $(".js-overlay-search").hide();
    $(".js-modal-search").hide();
  });
  $('.js-city-modal__link').click(function(e){
	e.preventDefault();
    var redirect = $(this).data('redirect');
    $.ajax({method:'POST', url:'/json/GetCitiesForm/', data: {redirect: redirect}}).then((data) => {
      $.fancybox.open(
        $.extend(true, {}, {
          type: 'html',
          touch: false,
          content: data.content,
        })
      );
      $('.js-city-modal .js-city-item').on('click',function(){
        var allInf = {
          city_id: $(this).data('city_id'),
          redirect: redirect
        };
        $.ajax({method:'POST',url:'/json/SelectCity/',data: allInf}).then((data) => {
			if (data.href) {
				window.location.replace(data.href);
			} else {
				window.location.reload();
			}
        })
      })
      $('.js-city__input').on('keyup',function(){
        if ($(this).val().length > 1) {
          $.ajax({
            method: "POST",
            url: "/cities/",
            data: { term: $(this).val()}
          }).then((data) => {
            $('.js-city__result').html('');
            $('.js-city__result').css('display','block');
            for (var i = 0; i < 50 && i<data.length; i++) {
              $('.js-city__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item">'+data[i].label+'</span></div>');
            }
            $('.js-city__result .js-city-item').on('click',function(){
              var allInf = {
                city_id: $(this).data('city_id'),
                redirect: redirect
              };
              $.ajax({method:'POST',url:'/json/SelectCity/',data: allInf}).then((data) => {
                window.location.href = data.href || location.href;
              })
            })
          })
        }
      })
      $('.js-city__input').click(function(){
        $('.js-city__result').css('display','block');
        $('.js-efects-click').addClass('active');
      })
      $('.js-city__input').on('focus',function(){
        $('.js-efects-click').addClass('active');
      })
      $(document).mouseup(function (e){
          var div1 = $(".js-efects-click");
          var div = $(".js-city__result");
          if ((!div1.is(e.target) && $('.js-city__input').val() == '')) {
            $('.js-efects-click').removeClass('active');
          }
          if ((!div.is(e.target) || !div1.is(e.target))) {
            $('.js-city__result').css('display','none');
          }
      })
    })
  })

  let lastScrollTop = 0;
	$(window).on('scroll', function(e) {
      let st = $(this).scrollTop();
  	  if (Math.abs(st - lastScrollTop) > 32) {
	      if (st > lastScrollTop && st > 48) {
	        $('.body').removeClass('m--up').addClass('m--down');
	      } else {
	        $('.body').removeClass('m--down').addClass('m--up');
	      }
	      lastScrollTop = st;
  	  }
	    let showOnTop = false;
	    if (window.pageYOffset > window.innerHeight) {
	        showOnTop = true;
	    }
	    if (showOnTop) {
	        $('.js-scroll-top').addClass('is-show');
	    } else {
	        $('.js-scroll-top').removeClass('is-show');
	    }
		if ($('.header--morph').length) {
			let headerInnerHeight = $('.header--morph').innerHeight();
			if (window.pageYOffset > headerInnerHeight) {
				$('.header--morph').addClass('header--page');
			} else {
				$('.header--morph').removeClass('header--page');
			}
		}
	});
	
	$('.js-scroll-top').on('click', function() {
	    $('html, body').animate({ scrollTop: 0 }, 1000);
	});
/* ---- */
	if ($('#select-city').length) {
      var redirect = $('#select-city').data('redirect');
	  if ($('#select-city').data('ajax')) {
        $.ajax({method:'POST',url:'/json/GetModalCities/'}).then((data) => {
			if (data.content) {
				$('#select-city').html(data.content);
				headerInitCityModal();
			}
        })
	  } else {
		headerInitCityModal();
	  }
	}

	function headerInitCityModal() {
      $('.js-city-modal .js-city-item').on('click',function(){
        var allInf = {
          city_id: $(this).data('city_id'),
          redirect: redirect
        };
        $.ajax({method:'POST',url:'/json/SelectCity/',data: allInf}).then((data) => {
			if (data.href) {
				window.location.replace(data.href);
			} else {
				window.location.reload();
			}
        })
      })
      $('.js-city__input').on('keyup',function(){
        if ($(this).val().length > 1) {
          $.ajax({
            method: "POST",
            url: "/cities/",
            data: { term: $(this).val()}
          }).then((data) => {
            $('.js-city__result').html('');
            $('.js-city__result').css('display','block');
            for (var i = 0; i < 50 && i<data.length; i++) {
              $('.js-city__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item">'+data[i].label+'</span></div>');
            }
            $('.js-city__result .js-city-item').on('click',function(){
              var allInf = {
                city_id: $(this).data('city_id'),
                redirect: redirect
              };
              $.ajax({method:'POST',url:'/json/SelectCity/',data: allInf}).then((data) => {
                window.location.href = data.href || location.href;
              })
            })
          })
        }
      })
      $('.js-city__input').click(function(){
        $('.js-city__result').css('display','block');
        $('.js-efects-click').addClass('active');
      })
      $('.js-city__input').on('focus',function(){
        $('.js-efects-click').addClass('active');
      })
      $(document).mouseup(function (e){
          var div1 = $(".js-efects-click");
          var div = $(".js-city__result");
          if ((!div1.is(e.target) && $('.js-city__input').val() == '')) {
            $('.js-efects-click').removeClass('active');
          }
          if ((!div.is(e.target) || !div1.is(e.target))) {
            $('.js-city__result').css('display','none');
          }
      })
	}
}


export {
  headerMain
};
